import { inject, Injectable } from '@angular/core';

import { map } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';
import type { IntercomArticle } from '@core/intercom-integration-types';

@Injectable({ providedIn: 'root' })
export class IntercomHttpService {
  private httpClient = inject(HttpApiService);

  public fetchArticles(perPage: number, page: number) {
    return this.httpClient
      .get('/intercom/articles', { perPage, page })
      .pipe(map((res): IntercomArticle[] => res.articles));
  }
}
